/** @format */

import {
  BankOutlined,
  HistoryOutlined,
  MehOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { Button, Card, Statistic } from "antd";
import React from "react";

type statisticProps = {
  tipe: string;
  title: string;
  total?: any;
  loading: any;
  handleClick: () => void;
};
const StatisticMadrasahBos: React.FC<statisticProps> = ({
  tipe,
  title,
  total,
  loading,
  handleClick,
}) => {
  let icon: any = <BankOutlined />;
  let bodyS: any = {};
  switch (tipe) {
    case "green":
      icon = <SmileOutlined />;
      bodyS = { background: "#89ff89" };
      break;
    case "yellow":
      icon = <HistoryOutlined />;
      bodyS = { background: "#ffe689" };
      break;
    case "red":
      icon = <MehOutlined />;
      bodyS = { background: "#ff8989" };
      break;
    default:
      icon = <BankOutlined />;
      break;
  }
  return (
    <Card className="shadow-md  p-4" bodyStyle={bodyS}>
      <Statistic title={title} value={total} loading={loading} prefix={icon} />
      <Button
        style={{ backgroundColor: "#222222", color: "#fff" }}
        onClick={handleClick}
        block
        loading={loading}>
        Lihat Detail
      </Button>
    </Card>
  );
};
export default StatisticMadrasahBos;
